'use client';

import { Skeleton } from '@/components/Skeleton';
import { useSliderHeight } from '@/modules/lobby/hooks';

export const LobbySliderSkeleton = () => {
  const height = useSliderHeight();

  return (
    <Skeleton.Container>
      <Skeleton.Rect height={height} />
    </Skeleton.Container>
  );
};
